export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15096.5628ff75.jpg";